import { MarvinConfig } from '@Constants/MarvinConstants';
import MarvinDataConverter from '@Services/MarvinDataConverter';
import defaults from 'lodash/defaults';

const ServiceName = 'MarvinImageExporter';

const getMarvinInstance = () => {
  return window.marvin;
};

const getBuiltInExporter = (format) => {
  return getMarvinInstance().ImageExporter[`${format}ToDataUrl`];
};

const error = (msg) => {
  Logger.error(msg);
  return Promise.reject();
};

class Exporter {
  render(opts) {
    return this.initDependencies()
      .then(() => {
        const marvin = getMarvinInstance();
        if (!marvin || !marvin.ImageExporter) {
          return error(`${ServiceName}: Marvin is not loaded.`);
        }
        const options = defaults(opts, MarvinConfig.defaultImageExporterOptions);
        const { format, data, imageType } = options;
        if (data) {
          return this.getExporter(format)(data, imageType, options);
        }
        return error(`${ServiceName}: Missing structure data for rendering.`);
      })
      .catch(Logger.reject);
  }

  getExporter = (format) => {
    let exporter = getBuiltInExporter(format);
    const marvin = getMarvinInstance();
    const builtInExporter = (...args) => {
      return new Promise((resolve) => {
        const result = exporter.apply(marvin.ImageExporter, args);
        resolve(result);
      });
    };
    const customExporter = (data, ...args) => {
      const intermediateFormat = MarvinConfig.intermediateImageExporterFormat;
      return MarvinDataConverter.convert(data, format, intermediateFormat)
        .then((convertedData) => {
          exporter = getBuiltInExporter(intermediateFormat);
          return exporter.apply(marvin.ImageExporter, [convertedData.structure].concat(args));
        })
        .catch(Logger.reject);
    };
    return exporter ? builtInExporter : customExporter;
  };

  initDependencies = () => {
    function marvinIsLoaded(onReady) {
      const marvin = getMarvinInstance();
      if (marvin && marvin.onReady) {
        marvin.onReady(onReady);
        return true;
      }
      return false;
    }
    if (!this.gui) {
      this.gui = new Promise((resolve, reject) => {
        if (!marvinIsLoaded(resolve)) {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          const errorMessage = `${ServiceName}: Can't load GUI script by URL '${MarvinConfig.GUI_SCRIPT}'`;
          script.onload = () => marvinIsLoaded(resolve) || reject(new Error(errorMessage));
          script.onerror = () => reject(new Error(errorMessage));
          script.src = MarvinConfig.GUI_SCRIPT;
          document.getElementsByTagName('head')[0].appendChild(script);
        }
      }).catch((err) => Logger.error(err));
    }
    return this.gui;
  };
}

const exporter = new Exporter();

export default exporter;
